import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "tw-grid tw-grid-cols-2" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "sm:tw-grid sm:tw-grid-cols-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "tw-text-right" }
const _hoisted_7 = { class: "tw-text-center" }
const _hoisted_8 = { class: "sf-table tw-mx-auto" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Word"),
    /*#__PURE__*/_createElementVNode("th", null, "Attempt 1"),
    /*#__PURE__*/_createElementVNode("th", null, "Attempt 2"),
    /*#__PURE__*/_createElementVNode("th", null, "Attempt 3")
  ])
], -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "tw-text-danger"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "tw-font-bold" }, "Results", -1)
const _hoisted_13 = { class: "tw-grid tw-grid-cols-4" }
const _hoisted_14 = { class: "tw-text-center" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", null, "1st Attempt", -1)
const _hoisted_16 = { class: "tw-text-center" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", null, "2nd Attempt", -1)
const _hoisted_18 = { class: "tw-text-center" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", null, "3rd Attempt", -1)
const _hoisted_20 = { class: "tw-text-center" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", null, "Incorrect 3 times", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrintTest = _resolveComponent("PrintTest")!

  return (_ctx.currentTestResult)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_PrintTest, {
            "test-result-id": _ctx.currentTestResult.id,
            "word-category-id": _ctx.testResultInfo?.wordCategoryId,
            "word-list-id": _ctx.testResultInfo?.wordListId,
            score: _ctx.printScore,
            "player-name": _ctx.studentName,
            "test-date": _ctx.testDate
          }, null, 8, ["test-result-id", "word-category-id", "word-list-id", "score", "player-name", "test-date"]),
          _createElementVNode("div", null, [
            (_ctx.testResults.length > 1)
              ? _withDirectives((_openBlock(), _createElementBlock("select", {
                  key: 0,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentTestIndex) = $event)),
                  class: "sf-form-control"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.testResults, (tr, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: tr.id,
                      value: index
                    }, _toDisplayString(_ctx.$filters.timeFormat(tr.createdon, "[dn] [d] [mn] [y] [h]:[i]", true)), 9, _hoisted_3))
                  }), 128))
                ], 512)), [
                  [_vModelSelect, _ctx.currentTestIndex]
                ])
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createTextVNode(" Date of test: "),
            _hoisted_5,
            _createTextVNode(" " + _toDisplayString(_ctx.$filters.timeFormat(_ctx.currentTestResult.createdon, "[dn] [d] [mn] [y] [h]:[i]", true)), 1)
          ]),
          _createElementVNode("div", _hoisted_6, "Student: " + _toDisplayString(_ctx.studentName), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("table", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.testWords, (w) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: w.word.id
                }, [
                  _createElementVNode("td", null, _toDisplayString(w.word.value), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(w.attempts, (att, i) => {
                    return (_openBlock(), _createElementBlock("td", { key: i }, [
                      (att.is_correct)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, "CORRECT"))
                        : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(att.input) + " (X)", 1))
                    ]))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(3 - w.attempts.length, (i) => {
                    return (_openBlock(), _createElementBlock("td", { key: i }))
                  }), 128))
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("div", null, _toDisplayString(_ctx.currentTestResult.scoreDetails?.a1) + " / " + _toDisplayString(_ctx.currentTestResult.scoreDetails?.tot), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", null, _toDisplayString(_ctx.currentTestResult.scoreDetails?.a2) + " / " + _toDisplayString(_ctx.currentTestResult.scoreDetails?.tot), 1)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", null, _toDisplayString(_ctx.currentTestResult.scoreDetails?.a3) + " / " + _toDisplayString(_ctx.currentTestResult.scoreDetails?.tot), 1)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", null, _toDisplayString(_ctx.currentTestResult.scoreDetails?.wrong) + " / " + _toDisplayString(_ctx.currentTestResult.scoreDetails?.tot), 1)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}